import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledModal = styled(Modal)`
  #vimeoContainer {
    // Vimeo default styling
    position: relative;
    flex: 1;
    

    iframe {
      width: 100%;
      height: 100%;
      min-height: 200px;
      
      @media (min-width: 768px) {
        min-height: 500px;
      }
    }
  }

  .modal-header {
    .modal-title {
      color: white;
      font-size: 18px;
    }
    .close {
      color: white;
    }
  }

  .modal-content {
    background: rgba(0, 0, 0, 0.7);
  }

  .modal-body {
    padding: 0;
  }

  .modal-footer {
    padding: 0;

    .c-button {
      padding: 0.375rem 0.75rem;
      font-size: 1rem;
    }
  }
`
